import * as ng from 'angular';
import { IOnChangesObject } from 'angular';

export class DefaultModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$state'
    ];

    private close: any;

    constructor(
        private $scope: any, // ng.IScope,
        private $state: any
    ) {
        $scope.config = $scope.$parent.$resolve.config;
        $scope.do = (btnId) => {
            this.close({ $value: btnId });
        };
    }
}


export const DefaultModalComponent: ng.IComponentOptions = {
    template: require('./default-modal.html'),
    controller: DefaultModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/default-modal/default-modal.ts